import { useTenantGraphQlClient, useCurrentContentGraphQlClient } from "@contember/react-client";
import { useMutation } from "./useMutation.js";
import { useQuery } from "./useQuery.js";
const useAuthedTenantQuery = (query, variables) => {
  const client = useTenantGraphQlClient();
  return useQuery(client, query, variables);
};
const useAuthedTenantMutation = (query) => {
  const client = useTenantGraphQlClient();
  return useMutation(client, query);
};
const useAuthedContentQuery = (query, variables) => {
  const client = useCurrentContentGraphQlClient();
  return useQuery(client, query, variables);
};
const useAuthedContentMutation = (query) => {
  const client = useCurrentContentGraphQlClient();
  return useMutation(client, query);
};
export {
  useAuthedContentMutation,
  useAuthedContentQuery,
  useAuthedTenantMutation,
  useAuthedTenantQuery
};
//# sourceMappingURL=auth.js.map
